import React from 'react';
import { Eye } from 'lucide-react';
import { VIEWER_BANNER_MESSAGE } from '../../../../utils/viewer-notice';

// Dải trạng thái đầu vùng nội dung admin cho tài khoản chỉ xem (bo 16px, icon trái).
const ViewerBanner = () => (
  <div role="status" className="adm-strip adm-strip--warning">
    <Eye size={20} className="adm-strip__icon" aria-hidden="true" />
    <span>{VIEWER_BANNER_MESSAGE}</span>
  </div>
);

export default ViewerBanner;
